import { defineStore } from 'pinia';

export enum OrganisationEditType {
    Organisation,
}
export interface OrganisationEditStoreState {
    create?: {
        type?: OrganisationEditType;
    };
    edit?: {
        key?: number;
        type?: OrganisationEditType;
    };
}

export const useOrganisationEditStore = defineStore('configuration-organisation-edit-store', {
    state: (): OrganisationEditStoreState => ({
        create: null,
        edit: null,
    }),
    getters: {
        isCreate(): (type: OrganisationEditType) => boolean {
            return (type: OrganisationEditType) => this.create?.type === type;
        },
        creating(): boolean {
            return this.create !== null && this.create?.type !== null;
        },
        isEdit(): (type: OrganisationEditType, id: number) => boolean {
            return (type: OrganisationEditType, id: number) => this.edit?.type === type && this.edit?.key === id;
        },
        editing(): boolean {
            return this.edit !== null && this.edit?.type !== null && this.edit?.key !== null;
        },
    },
    actions: {
        init(){
            this.create = null;
            this.edit = null;
        },
        openCreate(type: OrganisationEditType) {
            this.create = { type };
            this.edit = null;
        },
        closeCreate() {
            this.create = null;
        },
        openEdit(type: OrganisationEditType, key: number) {
            this.edit = { type, key };
            this.create = null;
        },
        closeEdit() {
            this.edit = null;
        },
    },
});
